import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";

export const jobbyCategoryApi = createApi({
  reducerPath: "jobbyCategoryApi",
  baseQuery: fetchBaseQuery({ baseUrl: process.env.REACT_APP_API_URL }),
  endpoints: (builder) => ({
    apijobbycategory: builder.query({
      query: () => `/job-by-category`,
    }),
  }),
});

export const { useApijobbycategoryQuery } = jobbyCategoryApi;